export const getHorsesFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`horses-${farm}`) || '""');

const mapToJson = (map: Map<string, string>) => {
  return JSON.stringify(Object.fromEntries(map));
};

export const putMicrochipLookupToLocalStorage = (farm: string, lookup: any) => {
  localStorage.setItem(`microchips-${farm}`, mapToJson(lookup));
};

export const getMicrochipLookupFromLocalStorage = (farm: string) => {
  const payload = localStorage.getItem(`microchips-${farm}`);
  return payload != null ? JSON.parse(payload) : null;
};

export const getHorseTemperaturesFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`horsesTemp-${farm}`) || '""');

export const getHorseProfileFromLocalStorage = (microchip: string) =>
  JSON.parse(localStorage.getItem(`horse-${microchip}`) || '""');

export const getHorseScheduleFromLocalStorage = (microchip: string) =>
  JSON.parse(localStorage.getItem(`horseSchedule-${microchip}`) || '""');

export const getShowDataFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`showData-${farm}`) || '""');

export const getShowListFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`showList-${farm}`) || '""');

export const getUserInfoFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`userInfo`) || '""');

export const getShowsFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`shows-${farm}`) || '""');

export const getEventPassDataByShowFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`evdatabyshow-${farm}`) || '""');

export const getHorseUpcomingShowsFromLocalStorage = (farm: string) =>
  JSON.parse(localStorage.getItem(`upcomingShows-${farm}`) || '""');
